export const TherapistFilterMenuSeparatorUI = () => <hr className="m-0 w-full border border-solid border-sand-400" />
